import React from 'react';
import { Header, Placeholder, Table } from 'semantic-ui-react';
import { Resultados } from 'src/api';
import { Dia, NombrePersonal } from 'src/componentes';
import { LinkCurso } from 'src/componentes/LinkCurso';

type Props = Readonly<{
    cargando: boolean;
    horario?: Resultados<'detalleDelAlumno'>;
}>;

export const CursosInscritos = (props: Props) => {
    const { cargando, horario } = props;

    if (cargando) return <Cargando />;
    if (!horario) return null;

    const { cursos } = horario;

    return (
        <div>
            <Header as='h2'>Cursos</Header>

            <Table celled compact textAlign='left'>
                <Table.Header>
                    <Table.Row textAlign='center'>
                        <Table.HeaderCell>Día</Table.HeaderCell>
                        <Table.HeaderCell>Horario</Table.HeaderCell>
                        <Table.HeaderCell>Curso</Table.HeaderCell>
                        <Table.HeaderCell>Sala</Table.HeaderCell>
                        <Table.HeaderCell>Profesor</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {cursos.map(curso => (
                        <Table.Row key={curso.id}>
                            <Table.Cell>
                                <Dia dia={curso.dia} />
                            </Table.Cell>
                            <Table.Cell>
                                {curso.bloqueHorario.horaInicio} – {curso.bloqueHorario.horaTermino}
                            </Table.Cell>

                            <Table.Cell selectable>
                                <LinkCurso codigo={curso.nombre} />
                            </Table.Cell>

                            <Table.Cell textAlign='right'>{curso.sala}</Table.Cell>
                            <Table.Cell>
                                {curso.profesor && (
                                    <NombrePersonal
                                        nombre={curso.profesor.nombre}
                                        patron='%N %P %m'
                                    />
                                )}
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </div>
    );
};

const Cargando = () => (
    <Placeholder fluid>
        <Placeholder.Header>
            <Placeholder.Line length='very short' />
            <Placeholder.Line length='very short' />
        </Placeholder.Header>
        <Placeholder.Paragraph>
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
        </Placeholder.Paragraph>
    </Placeholder>
);



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/InformacionGeneral/componentes/CursosInscritos.tsx